const generateComponentTheme = ({typography}) => {
  return {
    quizIconFontSize: typography.fontSizeXLarge,
  }
}

export default generateComponentTheme
